import { reportCreditTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_CREDIT, SET_REPORT_CREDIT_FILTERS } = reportCreditTypes;

const initialState = {
  ReportCredit: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportCreditReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_CREDIT:
      return { ...state, ReportCredit: payload };
    case SET_REPORT_CREDIT_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    default:
      return state;
  }
};
